/* 趙雲傳・第 3 章：截江（建安十六～十七年，211–212）
 * 史實：《趙雲傳》注引《雲別傳》「先主入益州，雲領留營司馬。此時先主孫夫人以權妹驕豪，多將吳吏兵，縱橫不法。
 *       先主以雲嚴重，必能整齊，特任掌內事。權聞備西徵，大遣舟船迎妹，而夫人內欲將後主還吳，雲與張飛勒兵截江，乃得後主還。」
 *       《二主妃子傳》注引《漢晉春秋》「先主入益州，吳遣迎孫夫人。夫人欲將太子歸吳，諸葛亮使趙雲勒兵斷江留太子，乃得止。」
 *       （演義第 61 回的周善、趙雲跳船、張飛殺周善，只放外傳。）
 * 流程：1. 在船上追孫夫人的大船，吳的小船會靠過來接舷拖慢你；大船出了江口就輸。
 *       2. 靠上大船：船停下，張飛的船從下游截住江面；擊退船上的吳吏兵（孫夫人打不得）。
 *       3. 在大船邊停住，把阿斗抱過來（船一動就要重來）。4. 載著阿斗划回公安碼頭。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, vanish } from '../kit.ts';
import { DOCK, FLAG0, EXIT_X, ZY0, ZF } from '../maps/zhaoyun_jiang.ts';
import { MEN, WU, SHU } from './zhaoyun_kit.ts';

const LV = 14, MID_X = 5000;
const WUB = { spec: WU, name: '吳吏兵', hp: 480, maxHp: 480, atk: 24 };
const landOk = (x, y) => SG.gd(x, y, DOCK[0], DOCK[1]) < 420;

export default {
  id: 'zhaoyun-3', map: 'zhaoyun_jiang', hero: 'zhaoyun',
  title: '第 4 章　截江', year: '建安十六、七年間（211–212）',
  brief: {
    quote: [{ text: '權聞備西徵，大遣舟船迎妹，而夫人內欲將後主還吳，雲與張飛勒兵截江，乃得後主還。', src: '《趙雲傳》注引《雲別傳》' }],
    text: '劉備西入益州，留趙雲在荊州掌管內事。孫權聽說劉備西征，派船來接妹妹孫夫人回吳；孫夫人想把阿斗一起帶走。（出處都在裴注；演義的周善、跳船只放外傳。）',
    goals: ['追上孫夫人的船', '截江：擊退船上的吳吏兵', '把阿斗抱過來', '回公安'],
  },
  words: { ally: '趙雲部', foe: '吳吏兵' },
  stars: [
    { text: '在中流之前截住大船', ok: (m) => m.vars.caughtX < MID_X },
    { text: '同船的部下沒有折損', ok: (m) => m.vars.crew.every((u) => u.alive) },
    { text: '回程沒被吳船接舷', ok: (m) => !m.vars.backHooked },
  ],
  steps: [
    { // 1. 追船
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        V.crew = Array.from({ length: 3 }, () => { const u = m.recruit(ZY0[0], ZY0[1], '趙雲部'); u.spec = SHU; return u; });
        V.b = m.boat(me, { x: ZY0[0], y: ZY0[1], sp: 220, crew: V.crew, land: false, flag: '#3e7b50' });
        const pilot = m.foe('huangjin', FLAG0[0], FLAG0[1], Object.assign({}, WUB, { name: '吳船', untargetable: true, atk: 0 }));
        V.wj = boss(w, MEN.wujiang, FLAG0[0], FLAG0[1], { name: '吳將', hp: 2600, atk: 38, armor: 6 });
        V.fsCrew = [V.wj, ...Array.from({ length: 4 }, () => m.foe('huangjin', FLAG0[0], FLAG0[1], WUB))];
        V.fs = m.boat(pilot, { x: FLAG0[0], y: FLAG0[1], sp: 105, crew: V.fsCrew, big: true, flag: '#b8433a', col: '#5a3a28', goal: [EXIT_X + 300, 2560] });
        V.lady = m.folk(V.fs.x, V.fs.y, { name: '孫夫人', still: true, near: 1 });
        V.adouF = m.folk(V.fs.x, V.fs.y, { name: '阿斗', still: true, near: 1 });
        V.esc = []; V.escT = 9;
        m.card('先主入益州，雲領留營司馬。此時先主孫夫人以權妹驕豪，多將吳吏兵，縱橫不法。先主以雲嚴重，必能整齊，特任掌內事。', '《雲別傳》（裴注）');
        m.after(5, () => m.line('留營兵', '將軍！孫夫人上了吳船，把小主人也帶走了！'));
        m.after(8, () => m.line('趙雲', '追！絕不能讓阿斗出江口。'));
        m.after(11, () => m.line('提示', '你在船上：右鍵點江面划船。吳的小船靠上來會拖慢你，先把它打沉。'));
        m.mark('fs', V.fs.x, V.fs.y, '孫夫人的船', false, pilot);
        m.obj('chase', '追上孫夫人的船');
      },
      tick(m, w, dt) {
        const V = m.vars, fs = V.fs, b = V.b;
        V.escT -= dt;
        if (V.escT <= 0) { V.escT = 15; V.esc.push(m.boat(m.foe('bandit', fs.x - 450, fs.y + (SG.rand() < 0.5 ? -260 : 260), Object.assign({}, WUB, { name: '吳船', hp: 520, maxHp: 520 })), { x: fs.x - 450, y: fs.y + (SG.rand() < 0.5 ? -260 : 260), small: true, sp: 200, flag: '#b8433a' })); }
        if (fs.x > EXIT_X) { m.lose('孫夫人的船出了江口，阿斗被帶回吳'); return false; }
        m.get('chase').text = `追上孫夫人的船（離江口 ${Math.max(0, Math.round((EXIT_X - fs.x) / 100))} 里）`;
        if (SG.gd(b.x, b.y, fs.x, fs.y) < 240) { V.caughtX = fs.x; return true; }
        return false;
      },
    },
    { // 2. 截江：擊退船上的吳吏兵
      enter(m, w) {
        const V = m.vars, fs = V.fs;
        m.done('chase');
        fs.goal = null; fs.stop = true;
        m.line('趙雲', '停船！');
        V.zf = ally(w, 'zhangfei', ZF[0], ZF[1], LV);
        const zc = Array.from({ length: 3 }, () => { const u = m.recruit(ZF[0], ZF[1], '張飛部'); u.spec = SHU; return u; });
        V.zfb = m.boat(V.zf, { x: ZF[0], y: ZF[1], sp: 240, crew: zc, flag: '#3e7b50', goal: [fs.x + 260, fs.y + 60] });
        m.after(1.5, () => m.line('張飛', '子龍！俺來了——江面截住了，一條船也別想走！'));
        m.after(4, () => m.line('提示', '靠在大船邊，擊退船上的吳吏兵。孫夫人打不得。'));
        m.obj('board', '擊退大船上的吳吏兵', V.fsCrew.length);
      },
      tick(m, w) {
        const V = m.vars, fs = V.fs;
        V.zfb.goal = SG.gd(V.zfb.x, V.zfb.y, fs.x + 260, fs.y + 60) > 30 ? [fs.x + 260, fs.y + 60] : null;
        // 接舷：靠近了就把兩條船併在一起（勾住大船）
        if (SG.gd(V.b.x, V.b.y, fs.x, fs.y) < 320 && !w.player.input.moveTo && SG.gd(V.b.x, V.b.y, fs.x - 70, fs.y - 35) > 12) V.b.goal = [fs.x - 70, fs.y - 35];
        const dead = V.fsCrew.filter((u) => !u.alive).length;
        m.prog('board', dead);
        return dead >= V.fsCrew.length;
      },
    },
    { // 3. 奪後主
      enter(m, w) {
        m.done('board');
        m.line('孫夫人', '我帶自己的兒子回娘家，你們誰敢攔？');
        m.after(3, () => m.line('趙雲', '後主是主公的骨肉。請夫人自回，阿斗留下。'));
        m.after(5, () => m.line('提示', '把船停在大船邊不動，抱阿斗過來。'));
        m.obj('adou', '在大船邊停住，把阿斗抱過來');
      },
      tick(m, w) {
        const me = w.player, V = m.vars, b = V.b, fs = V.fs;
        if (!V.adou && !me.chan && SG.gd(b.x, b.y, fs.x, fs.y) < 260 && b.still > 0.3) m.chan(me, 3, '抱回阿斗', () => { V.adou = true; m.line('阿斗', '（哭）'); m.after(2, () => m.line('趙雲', '小主人別怕，雲帶你回家。')); }, { hurt: false });
        return !!V.adou;
      },
    },
    { // 4. 回公安
      enter(m, w) {
        const V = m.vars, fs = V.fs, b = V.b;
        m.done('adou');
        fs.stop = false; fs.goal = [EXIT_X + 600, 2560]; // 孫夫人自回吳
        b.land = true; b.landOk = landOk;
        for (let i = 0; i < 2; i++) V.esc.push(m.boat(m.foe('bandit', fs.x + 300, fs.y + (i ? 300 : -300), Object.assign({}, WUB, { name: '吳船', hp: 750, maxHp: 750 })), { x: fs.x + 300, y: fs.y + (i ? 300 : -300), small: true, sp: 200, flag: '#b8433a' }));
        m.line('張飛', '子龍先走，俺斷後！');
        m.mark('dock', DOCK[0], DOCK[1], '公安碼頭');
        m.obj('back', '載著阿斗划回公安碼頭（從碼頭前的淺灘靠岸）');
      },
      tick(m, w) {
        const V = m.vars;
        if (V.zfb.u.boat) V.zfb.goal = [V.b.x + 300, V.b.y + 120];
        if (V.hooked) V.backHooked = true;
        if (V.fs.x > EXIT_X) { vanish(w, V.fs.u); m.unboat(V.fs); V.lady.x = V.adouF.x = -9999; }
        return !w.player.boat;
      },
    },
    { // 5. 乃得後主還
      enter(m, w) {
        m.done('back'); m.unmark('dock');
        m.card('雲與張飛勒兵截江，乃得後主還。', '《雲別傳》（裴注）');
        m.after(5, () => m.card('夫人欲將太子歸吳，諸葛亮使趙雲勒兵斷江留太子，乃得止。', '《二主妃子傳》注引《漢晉春秋》'));
        m.after(10, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const V = m.vars, b = V.b;
    if (!w.player.alive) { m.lose('趙雲陣亡'); return; }
    // 孫夫人、阿斗在大船上（抱過來之後阿斗在趙雲的船上）
    if (V.fs && V.fs.u.boat) { V.lady.x = V.fs.x + 30; V.lady.y = V.fs.y - 6; }
    if (V.adouF) { const s = V.adou ? b : V.fs; if (s.u.boat || s === b) { V.adouF.x = s.x - 20; V.adouF.y = s.y + 4; } }
    // 吳的小船：靠過來接舷；接上了趙雲的船就慢下來
    V.hooked = false;
    for (const sb of V.esc) {
      if (!sb.u.alive) continue;
      const d = SG.gd(sb.x, sb.y, b.x, b.y);
      sb.goal = d > 70 ? [b.x + (sb.x < b.x ? -60 : 60), b.y + (sb.y < b.y ? -20 : 20)] : null;
      if (d < 150) V.hooked = true;
    }
    b.sp = V.hooked ? 100 : 220;
    if (V.zf && m.i >= 1) allyTick(w, V.zf, null, 420);
  },
};
